
















import { Component, Prop, Vue } from 'nuxt-property-decorator'
import ComponentLoadingDots from '~/components/loading/dots.vue'

let observer: IntersectionObserver

@Component({
  components: {
    ComponentLoadingDots,
  },
})
export default class ComponentIntersect extends Vue {
  @Prop({ type: Array, required: false, default: () => [0] })
  private threshold!: number[]

  @Prop({
    type: Boolean,
    default: false,
  })
  private serverRender!: boolean

  @Prop({
    type: typeof HTMLElement !== 'undefined' ? HTMLElement : Object,
    required: false,
    default: () => null,
  })
  private root!: HTMLElement

  @Prop({
    type: String,
    required: false,
    default: () => '0px 0px 0px 0px',
  })
  private rootMargin!: string

  private IsIntersectionObserverInit = false

  private isIntersect = false

  private mounted() {
    setTimeout(this.initObserver)
  }

  private initObserver() {
    observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          this.isIntersect = true
        }
      },
      {
        threshold: this.threshold,
        root: this.root,
        rootMargin: this.rootMargin,
      }
    )

    this.$nextTick(() => {
      this.observe()
    })
  }

  private observe() {
    observer.observe(this.$el)
  }

  private disconnect() {
    observer.disconnect()
  }
}
